import moduleList from '../views/moduleConfManagement/moduleList'
import sectionList from '../views/moduleConfManagement/sectionList'
import moduleVideoList from '../views/moduleConfManagement/videoList'
import HappinessPlazaTopList from '../views/moduleConfManagement/happinessPlazaTopList'
import kingKongDistrict from '../views/moduleConfManagement/kingKongDistrict'
import Main from "../views/main";

const moduleConfRouter={
    path: "/module-conf-management",
    component: Main,
    title: "模块配置管理",
    icon: "el-icon-s-promotion",
    meta: { keepAlive: true },
    children: [
      {
        path: "/module-list",
        component: moduleList,
        name: "moduleList",
        title: "模块列表",
        meta: { title: "模块列表", keepAlive: true },
      },
      {
        path: "/section-list",
        component: sectionList,
        name: "sectionList",
        title: "专题列表",
        meta: { title: "专题列表", keepAlive: true },
      },
      {
        path: "/module-video-list",
        component: moduleVideoList,
        name: "moduleVideoList",
        title: "视频列表",
        meta: { title: "视频列表", keepAlive: true },
      },
      {
        path: '/happinessPlaza',
        component: HappinessPlazaTopList,
        name: 'happinessPlazaTopList',
        title: '幸福广场置顶列表',
        meta: { title: '幸福广场置顶列表' ,keepAlive:true}
      },
      {
        path: '/kingKongDistrict',
        component: kingKongDistrict,
        name: 'kingKongDistrict',
        title: '金刚区',
        meta: { title: '金刚区列表' ,keepAlive:true}
      },
    ]
}
export default moduleConfRouter;